
export const exportShiptoHeaders= [
    { 
        label: "Loyalty Id", 
        key:"loyalty_id" 
    },
    
    { 
        label: "Billto ID", 
        key:"customer_billto_account_number" 
    },
    { 
        label: "Shipto ID", 
        key: "customer_account_number"
    },
    {
        label: "Enrollment Date/Time",
        key: "created_at",
    },
    { 
        label: "Sales Summary Tier", 
        key: "sales_summary_tier" 
    },
    { 
        label: "Tier", 
        key: "tier" 
    },
    { 
        label: "System Managed", 
        key: "system_managed" 
    },
    { 
        label: "Membership Status", 
        key: "is_active"
    },
    // { 
    //     label: "Code Assignment", 
    //     key: "code_assignment"
    // },
    { 
        label: "Anniversary Start Date", 
        key: "tier_start_date"
    },
    { 
        label: "Anniversary End Date", 
        key: "tier_end_date"
    },
    
    { 
        label: "Type", 
        key: "privilege_type"
    },
    { 
        label: "Code", 
        key: "privilege_code"
    },
    // { 
    //     label: "Code Assignment shipto", 
    //     key: "code_assignment_1"
    // },
    { 
        label: "Shipto Status", 
        key: "is_active_1"
    },
    { 
        label: "Consent", 
        key: "consent_flag"
    },
    { 
        label: "Consent Date", 
        key: "consent_date"
    }
   

]

export const exportBuildtoHeaders = [
    { 
        label: "Loyalty Id", 
        key:"loyalty_id" 
    },
    { 
        label: "Billto ID", 
        key:"customer_billto_account_number" 
    },
    {
        label: "Enrollment Date/Time",
        key: "created_at",
    },
    { 
        label: "Sales Summary Tier", 
        key: "sales_summary_tier" 
    },
    { 
        label: "Tier", 
        key: "tier" 
    },
    { 
        label: "System Managed", 
        key: "system_managed" 
    },
    { 
        label: "Membership Status", 
        key: "is_active"
    },
    // { 
    //     label: "Code Assignment", 
    //     key: "code_assignment"
    // },
    { 
        label: "Anniversary Start Date", 
        key: "tier_start_date"
    },
    { 
        label: "Anniversary End Date", 
        key: "tier_end_date"
    },
    { 
        label: "Consent", 
        key: "consent_flag"
    },
    { 
        label: "Consent Date", 
        key: "consent_date"
    },
    
]

export const exportcontractHeaders = [
    { 
        label: "Loyalty Id", 
        key:"loyalty_id" 
    },
    { 
        label: "Billto ID", 
        key:"customer_billto_account_number" 
    },
    {
        label: "Shipto ID",
        key: "customer_account_number",
    },
    { 
        label: "Start Date", 
        key: "start_date" 
    },
    { 
        label: "End_Date", 
        key: "end_date" 
    },
    { 
        label: "Privilege Code", 
        key: "contract_code" 
    },
    // { 
    //     label: "Column Name", 
    //     key: "column_name"
    // },

    { 
        label: "Altered by", 
        key: "altered_by"
    },

    { 
        label: "Altered User", 
        key: "email"
    },

   
   
]